<template>
  <v-container class="mnh-800 mxw-700 py-4 mt-3">
    <transition :name="transitionName" mode="out-in">
      <v-progress-linear class="mb-4" color="primary" v-if="step < 6" v-model="progress"></v-progress-linear>
    </transition>
    <transition :name="transitionName" mode="out-in">
      <router-view :search="search"></router-view>
    </transition>
    <transition :name="transitionName" mode="out-in">
      <v-row class="mb-5" v-if="step < 6">
        <v-col class="d-inline-flex">
          <v-btn @click="stepBack()" class="mxw-125" large outlined text v-show="step > 1">Back</v-btn>
          <v-spacer></v-spacer>
          <v-btn :disabled="submitDisabled" @click="stepForward()" class="mr-0 mxw-125" color="primary" large v-if="step < 5">Next</v-btn>
          <v-btn :disabled="submitted || submitDisabled" @click="submit()" class="c-white mr-0 mr-0 mx-auto px-4 fw-600" color="secondary" depressed large light v-if="step == 5">Submit My Search</v-btn>
        </v-col>
      </v-row>
    </transition>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import { SearchParams } from '../services/search_params'

export default {
  computed: {
    submitDisabled: function() {
      if(this.step == 2) {
        return this.search.stage < 0
      } else if(this.step == 3) {
        return !this.search.coverage || !this.search.pickup || !this.search.dropoff
      } else if(this.step == 5) {
        return !this.search.origin ||
        (this.search.location_type == 'commute' && !(this.search.destination && this.search.travel_mode))
      }
      return false
    },

    progress: function() {
      return (this.step / 7) * 100
    }
  },

  created: function() {
    if(this.step != this.$route.meta.step) {
      this.step = 0
      this.$router.replace({ name: 'New' })
    }
    this.load()
  },

  data: function() {
    return {
      loaded: false,
      search: {
        coverage: '',
        destination: null,
        dropoff: '',
        formatted_destination: '',
        formatted_origin: '',
        location_type: false,
        max_age: 12,
        min_age: 0,
        name: '',
        origin: null,
        pickup: '',
        stage: -1,
        start: '',
        travel_mode: null,
      },
      transitionName: 'slide-left',
      submitted: false,
      step: 1
    }
  },

  methods: {
    load: function() {
    },

    stepBack: function() {
      this.step = this.step - 1
      this.transitionName = 'slide-right'
      this.$router.go(-1)
    },

    stepForward: function() {
      this.step = this.step + 1
      this.transitionName = 'slide-left'
      this.$router.push({ name: 'SearchStep' + this.step })
    },

    submit: function() {
      this.submitted = true
      this.stepForward()
      var vm = this
      let params = new SearchParams(this.search)

      firebase.functions().httpsCallable('submitSearch')({ uid: this.$store.state.user.uid, search: params.asJson() }).then((resp) => {
        firebase.auth().currentUser.getIdTokenResult(true).then((idTokenResult) => {
          window.bf_api_token = idTokenResult.claims.bfToken
          vm.$router.replace({ name: 'SearchShow', params: { searchId: resp.data.id } })
        })
      }).catch((err) => {
        alert(err)
        vm.stepBack()
        vm.submitted = false
      })
    },
  },
}
</script>
